import { render, staticRenderFns } from "./CatalogProducts.vue?vue&type=template&id=3deb3904&scoped=true&"
import script from "./CatalogProducts.vue?vue&type=script&lang=js&"
export * from "./CatalogProducts.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProducts.vue?vue&type=style&index=0&id=3deb3904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb3904",
  null
  
)

export default component.exports